import { useEventListener } from './useEventListener'

export const useResizeListener = (onResizeChange: (value: UIEvent) => void): void =>
  useEventListener('resize', onResizeChange, { passive: true })
